<template>
    <u-select-filled-rounded v-model="modelValue" v-bind="$attrs" @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-select-filled-rounded>
</template>

<script>
import USelectFilledRounded from "@/components/publish/styles/forms/u-select-filled-rounded.vue";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {
        USelectFilledRounded,
    },
    data() {
        return {
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
